import { type MonetarySeparators, isAsciiDigit } from "./format";

/**
 * Maps the caret across a reformat: counts the digits left of the caret in the pre-format
 * string and walks the formatted string to the same digit count, so grouping characters
 * inserted/removed by the reformat never displace the caret relative to its surrounding
 * digits. A decimal separator immediately left of the old caret is preserved (the caret
 * stays after it) so the user can keep typing the fractional part.
 */
export function mapCaretAcrossFormat(
	previous: string,
	previousCaret: number,
	formatted: string,
	{ decimalChar }: Pick<MonetarySeparators, "decimalChar">,
): number {
	let digitsLeftOfCaret = 0;
	for (let i = 0; i < previousCaret && i < previous.length; i++) {
		if (isAsciiDigit(previous[i])) {
			digitsLeftOfCaret++;
		}
	}
	let caret = 0;
	let digitsSeen = 0;
	while (caret < formatted.length && digitsSeen < digitsLeftOfCaret) {
		if (isAsciiDigit(formatted[caret])) {
			digitsSeen++;
		}
		caret++;
	}
	if (previousCaret > 0 && previous[previousCaret - 1] === decimalChar && formatted[caret] === decimalChar) {
		caret++;
	}
	return caret;
}
